import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserCircle, Briefcase, CheckSquare, Star, FileText, ChevronRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const ROLE_LABEL = { candidate: "Candidato / Candidate", employer: "Empleador / Employer", admin: "Admin", subadmin: "Subadmin" };

export default function Dashboard() {
  const { t } = useTranslation();
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "employer") return <Navigate to="/employer" replace />;
  if (user.role === "admin" || user.role === "subadmin") return <Navigate to="/admin" replace />;

  const candidateLinks = [
    { to: "/candidate/applications", icon: CheckSquare, label: t("dashboard.myApplications") },
    { to: "/candidate/saved", icon: Star, label: t("dashboard.savedJobs") },
    { to: "/candidate/request", icon: FileText, label: t("dashboard.myRequest") },
    { to: "/candidate/profile", icon: UserCircle, label: t("dashboard.myProfile") },
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
      <div className="bg-white rounded-2xl border border-stone-border shadow-sm p-8 mb-6" data-testid="dashboard-panel">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-brand-soft flex items-center justify-center">
            <UserCircle className="w-9 h-9 text-brand" />
          </div>
          <div>
            <h1 className="font-heading text-2xl font-bold text-stone-text" data-testid="dashboard-name">
              {t("dashboard.welcome")}, {user.name}
            </h1>
            <p className="text-stone-muted text-sm">{user.email}</p>
            <span className="inline-block mt-1 text-xs font-semibold px-2.5 py-0.5 rounded-full bg-brand-soft text-brand" data-testid="dashboard-role">
              {ROLE_LABEL[user.role] || user.role}
            </span>
          </div>
        </div>
      </div>

      {user.role === "candidate" ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="candidate-hub">
          {candidateLinks.map((l) => {
            const Icon = l.icon;
            return (
              <Link key={l.to} to={l.to} className="flex items-center justify-between bg-white rounded-2xl border border-stone-border shadow-sm p-5 hover:shadow-md hover:-translate-y-0.5 transition-all">
                <span className="flex items-center gap-3 font-heading font-semibold text-stone-text">
                  <span className="w-10 h-10 rounded-xl bg-brand-soft flex items-center justify-center"><Icon className="w-5 h-5 text-brand" /></span>
                  {l.label}
                </span>
                <ChevronRight className="w-5 h-5 text-stone-muted" />
              </Link>
            );
          })}
        </div>
      ) : (
        <div className="bg-stone-bg rounded-xl p-6 text-center">
          <p className="text-stone-sub">{t("dashboard.comingSoon")}</p>
          <Link to="/jobs" className="inline-flex items-center gap-2 mt-4 px-5 py-2.5 rounded-xl bg-brand text-white font-semibold hover:bg-brand-hover transition-colors">
            <Briefcase className="w-4 h-4" /> {t("dashboard.browseJobs")}
          </Link>
        </div>
      )}
    </div>
  );
}
